<script setup lang="ts">
</script>

<template>
  <footer class="bg-blue-950 text-[oklch(80%_0.02_240)] pt-12 md:pt-16 pb-6 md:pb-10">
    <div class="container-main pb-safe">
      <div class="flex flex-col gap-8 md:flex-row md:items-start md:justify-between md:gap-12 mb-8 md:mb-12">
        <!-- 品牌 -->
        <div class="max-w-sm">
          <h3 class="font-heading text-lg text-white mb-3">FOSS LEGAL</h3>
          <p class="text-sm opacity-70 leading-relaxed">
            开源法律社区致力于推动中国开源软件合规生态建设，连接法律智慧与技术力量，为开源产业的健康发展提供专业支撑。
          </p>
        </div>

        <!-- 链接 -->
        <div class="flex flex-col gap-3">
          <RouterLink
            to="/policy/privacy"
            class="text-sm opacity-70 transition-colors duration-150 hover:text-white no-underline"
          >
            网站隐私声明
          </RouterLink>
          <RouterLink
            to="/policy/code-of-conduct"
            class="text-sm opacity-70 transition-colors duration-150 hover:text-white no-underline"
          >
            社区行为守则
          </RouterLink>
        </div>

        <!-- 邮箱 -->
        <div>
          <span class="text-sm opacity-70">邮箱:</span>
          <a
            href="mailto:legal@openatom.org"
            class="text-sm opacity-70 transition-colors duration-150 hover:text-white no-underline self-start md:self-auto"
          >
            legal@openatom.org
          </a>
        </div>
      </div>

      <!-- 底栏 -->
      <div class="border-t border-[oklch(100%_0_0/0.1)] pt-6 md:pt-8 text-center text-xs opacity-50">
        <p>&copy; 2026 开源法律社区 FOSS LEGAL. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>
